import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const getLocaleFromCookie = () => {
  const match = document.cookie.match(/(^|;)\s*locale=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : "en";
};

const getUrlHasThankYou = () => {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  return params.get("thankyou") === "1" || params.get("status") === "submitted";
};

const ContactForm = ({ title, preTitle }) => {
  const { t } = useTranslation();
  const siteKey = "6Ld7pCErAAAAAN-Aw-ChxsmwXX6DiArl_xJuqLlK";
  const locale = getLocaleFromCookie();
  const [submitted, setSubmitted] = useState(getUrlHasThankYou());

  useEffect(() => {
    if (submitted) return;

    if (!window.MauticSDKLoaded) {
      window.MauticSDKLoaded = true;

      const mauticScript = document.createElement("script");
      mauticScript.src = "https://engage.lussana.me/media/js/mautic-form.js?va9981c41";
      mauticScript.crossOrigin = "anonymous";
      mauticScript.onload = () => window.MauticSDK?.onLoad?.();
      document.head.appendChild(mauticScript);

      const recaptchaScript = document.createElement("script");
      recaptchaScript.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      recaptchaScript.async = true;
      recaptchaScript.defer = true;
      document.head.appendChild(recaptchaScript);
    }

    const trySetLocale = () => {
      const localeInput = document.getElementById("mauticform_input_guestbookmostra_locale");
      if (localeInput) {
        localeInput.value = locale;
      } else {
        setTimeout(trySetLocale, 200);
      }
    };

    trySetLocale();
  }, [submitted, locale]);

const handleSubmit = () => {
  const returnInput = document.getElementById("mauticform_guestbookmostra_return");
  if (returnInput) {
    returnInput.value = `${window.location.pathname}?thankyou=1`;
  }

  const countryCode = document.getElementById("countryCode")?.value || "";
  const phoneNumber = document.getElementById("phoneNumber")?.value || "";
  const combinedPhone = document.getElementById("mauticform_input_guestbookmostra_telefono");

  if (combinedPhone) {
    combinedPhone.value = `${countryCode}${phoneNumber}`.replace(/\s+/g, "");
  }
};


  return (
    <>
      <style>{`.mauticform-field-hidden { display: none; }`}</style>

      <div className="container">
        <div className="row mb-5 g-3 g-xl-5 align-items-end">
          <div className="col-lg-12">
            {submitted ? (
              <p className="mt-5" style={{ lineHeight: "80%" }}>
                <span className="display-5" style={{ fontWeight: "bold", lineHeight: "50%" }}>
                  {t("expo.thankYou", "Muchas gracias por tomarse el tiempo de dejar un mensaje tras visitar la exposici�n. Significa mucho para m� contar con su apoyo y presencia.")}
                </span>
              </p>
            ) : (
              <form
                autoComplete="off"
                role="form"
                method="post"
                action="https://engage.lussana.me/form/submit?formId=7"
                id="mauticform_guestbookmostra"
                data-mautic-form="contactme"
                encType="multipart/form-data"
                onSubmit={handleSubmit}
                className="row g-3 mt-4"
              >
                <div className="col-md-6">
                  <label className="form-label">{t("contacts.firstName", "Nombre")}</label>
                  <input
                    type="text"
                    name="mauticform[nombre]"
                    id="mauticform_input_guestbookmostra_nombre"
                    className="form-control"
                    placeholder={t("contacts.firstName", "Nombre")}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">{t("contacts.lastName", "Apellido(s)")}</label>
                  <input
                    type="text"
                    name="mauticform[apellidos]"
                    id="mauticform_input_guestbookmostra_apellidos"
                    className="form-control"
                    placeholder={t("contacts.lastName", "Apellido(s)")}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">{t("contacts.emailAddress", "Correo electr�nico")}</label>
                  <input
                    type="email"
                    name="mauticform[correo_electronico]"
                    id="mauticform_input_guestbookmostra_correo_electronico"
                    className="form-control"
                    placeholder={t("contacts.emailAddress", "Correo electr�nico")}
                    required
                  />
                </div>

                <div className="col-md-6">
  <label className="form-label">{t("contacts.mobile", "M�vil")}</label>
  <div className="d-flex gap-2">
    <select
      id="countryCode"
      className="form-select"
      style={{ maxWidth: "120px" }}
      defaultValue="+34" required
    >

<option value="+34">🇪🇸 +34</option>
  <option value="+52">🇲🇽 +52</option>
  <option value="+54">🇦🇷 +54</option>
  <option value="+56">🇨🇱 +56</option>
  <option value="+57">🇨🇴 +57</option>
  <option value="+51">🇵🇪 +51</option>
  <option value="+598">🇺🇾 +598</option>
  <option value="+595">🇵🇾 +595</option>
  <option value="+591">🇧🇴 +591</option>
  <option value="+503">🇸🇻 +503</option>
  <option value="+502">🇬🇹 +502</option>
  <option value="+504">🇭🇳 +504</option>
  <option value="+505">🇳🇮 +505</option>
  <option value="+506">🇨🇷 +506</option>
  <option value="+507">🇵🇦 +507</option>
  <option value="+58">🇻🇪 +58</option>
  <option value="+53">🇨🇺 +53</option>
  <option value="+1">🇩🇴 +1</option>
  <option value="+1">🇵🇷 +1</option>
  <option value="+33">🇫🇷 +33</option>
  <option value="+49">🇩🇪 +49</option>
  <option value="+39">🇮🇹 +39</option>
  <option value="+41">🇨🇭 +41</option>
  <option value="+31">🇳🇱 +31</option>
  <option value="+32">🇧🇪 +32</option>
  <option value="+351">🇵🇹 +351</option>
  <option value="+43">🇦🇹 +43</option>
  <option value="+36">🇭🇺 +36</option>
  <option value="+420">🇨🇿 +420</option>
  <option value="+421">🇸🇰 +421</option>
  <option value="+386">🇸🇮 +386</option>
  <option value="+385">🇭🇷 +385</option>
  <option value="+48">🇵🇱 +48</option>
  <option value="+47">🇳🇴 +47</option>
  <option value="+46">🇸🇪 +46</option>
  <option value="+45">🇩🇰 +45</option>
  <option value="+44">🇬🇧 +44</option>
  <option value="+358">🇫🇮 +358</option>
  <option value="+357">🇨🇾 +357</option>
  <option value="+371">🇱🇻 +371</option>
  <option value="+370">🇱🇹 +370</option>
  <option value="+372">🇪🇪 +372</option>
  <option value="+353">🇮🇪 +353</option>
  <option value="+1">🇺🇸 +1</option>
  <option value="+55">🇧🇷 +55</option>
  <option value="+592">🇬🇾 +592</option>
  <option value="+593">🇪🇨 +593</option>
  <option value="+597">🇸🇷 +597</option>
  <option value="+501">🇧🇿 +501</option>
  <option value="+1">🇨🇦 +1</option>
  <option value="+1">🇯🇲 +1</option>
  <option value="+61">🇦🇺 +61</option>
  <option value="+64">🇳🇿 +64</option>
  <option value="+81">🇯🇵 +81</option>
  <option value="+82">🇰🇷 +82</option>
  <option value="+91">🇮🇳 +91</option>
  <option value="+86">🇨🇳 +86</option>
  <option value="+62">🇮🇩 +62</option>
  <option value="+63">🇵🇭 +63</option>
  <option value="+65">🇸🇬 +65</option>
  <option value="+60">🇲🇾 +60</option>
  <option value="+66">🇹🇭 +66</option>
  <option value="+90">🇹🇷 +90</option>
  <option value="+7">🇷🇺 +7</option>
  <option value="+27">🇿🇦 +27</option>
  <option value="+234">🇳🇬 +234</option>
  <option value="+212">🇲🇦 +212</option>
    </select>

    <input
      type="tel"
      id="phoneNumber"
      className="form-control"
      placeholder={t("contacts.mobile")}
      required
    />
  </div>

  {/* Hidden combined field for Mautic */}
  <input
    type="hidden"
    name="mauticform[telefono]"
    id="mauticform_input_guestbookmostra_telefono"
  />
</div>


                <div className="col-md-12">
                  <label className="form-label">{t("contacts.message", "Mensaje")}</label>
                  <textarea
                    name="mauticform[f_message]"
                    id="mauticform_input_guestbookmostra_f_message"
                    className="form-control"
                    placeholder={t("contacts.message", "Mensaje")}
                    required
                  ></textarea>
                </div>

                <input
                  type="hidden"
                  name="mauticform[locale]"
                  id="mauticform_input_guestbookmostra_locale"
                  value={locale}
                />

                <div className="col-md-12">
                  <button
                    type="submit"
                    className="btn btn-black w-100"
                    name="mauticform[submit]"
                    value="1"
                    id="mauticform_input_contactme_submit"
                    style={{ textTransform: "uppercase" }}
                  >
                    {t("contacts.submit")}
                  </button>
                </div>

                <input type="hidden" name="mauticform[formId]" value="7" />
                <input type="hidden" name="mauticform[return]" id="mauticform_guestbookmostra_return" value="" />
                <input type="hidden" name="mauticform[formName]" id="mauticform_guestbookmostra_name" value="guestbookmostra" />

                <div className="col-12">
                  <p className="text-muted small mt-3">
                    {t("contacts.recaptchaNotice")}{" "}
                    <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
                      {t("contacts.privacyPolicy")}
                    </a>{" "}
                    {t("contacts.and")}{" "}
                    <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">
                      {t("contacts.termsOfService")}
                    </a>.
                  </p>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactForm;
